import { type FeatureModule } from '@store/features/types';

/**
 * Payer Search feature module definition
 *
 * This is a minimal API-only feature that doesn't require local state management.
 * The feature uses RTK Query for all data fetching and caching.
 */
export const payerSearchFeature: FeatureModule = {
  // Basic feature identification
  id: 'payerSearch',
  name: 'Payer Search',

  // No dependencies for this feature
  dependencies: [],

  // No reducers needed - this is an API-only feature
  reducers: {},

  // No middleware needed - API middleware is registered globally
  middleware: [],

  // No persistence needed for this API-only feature
  persistence: {
    enabled: false,
  },

  // No sync needed for this API-only feature
  sync: {
    enabled: false,
  },

  // Feature lifecycle hooks
  setup: _store => {
    // Feature initialization logic if needed
  },

  cleanup: _store => {
    // Feature cleanup logic if needed
  },
};

